import { Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime, distinctUntilChanged, of, Subject, switchMap } from 'rxjs';
import { SearchDataService } from '../../services/search/search-data.service';

@Component({
  selector: 'app-vendor-search',
  templateUrl: './vendor-search.component.html',
  styleUrls: ['./vendor-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VendorSearchComponent),
      multi: true
    }
  ]
})
export class VendorSearchComponent implements OnInit {

  allResultsData: any[] = [];
  filteredResults: any[] = [];
  searchText: string = '';

  @Input() disableType: boolean = false;

  @Output() vendorDataEmitter: EventEmitter<any> = new EventEmitter();

  private searchSubject = new Subject<string>();

  selectedItem: any;
  private onChange!: (value: any) => void;
  private onTouched!: () => void;

  constructor(private _searchDataService: SearchDataService,
    private _elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.searchSubject.pipe(
      debounceTime(300), // wait 300ms after typing stops
      distinctUntilChanged(),
      switchMap((searchText: string) => {
        if (!searchText.trim() || searchText.length < 2) return of([]);

        return this._searchDataService.searchVendorByKeyword(searchText);

      })
    ).subscribe((data: any[]) => {
      this.filteredResults = (data || []).map(item => ({
        ...item,
        displayName: `${item.firstName} ${item.lastName} (${item.vendorId})`
      }));
    });
  }

  writeValue(value: any): void {
    if (value) {
      this.selectedItem = value;
      this.searchText = `${value.firstName} ${value.lastName} (${value.vendorId})`;
    } else {
      this.selectedItem = null;
      this.searchText = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disableType = isDisabled;
  }

  onSearchTextChange(): void {
    this.searchSubject.next(this.searchText);
  }

  selectItem(item: any): void {
    this.selectedItem = item;
    this.searchText = `${item.firstName} ${item.lastName} (${item.vendorId})`;
    this.filteredResults = [];
    this.vendorDataEmitter.emit(item);
    this.onChange(item);
    this.onTouched();
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    if (!this._elementRef.nativeElement.contains(targetElement)) {
      // this.dropdownVisible = false;
      this.filteredResults = [];
    }
  }

}
